"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TickMark = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable import/prefer-default-export */


var TickMark = function TickMark(_ref) {
  var width = _ref.width,
      color = _ref.color;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 16 11",
    style: {
      width: width
    }
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(-27 -1804)"
  }, _react.default.createElement("g", {
    stroke: color || "#33cc99",
    transform: "translate(29 1806)"
  }, _react.default.createElement("polyline", {
    strokeWidth: "3",
    points: "0 3.3518 4.044 7.5 12 0"
  }))));
};

exports.TickMark = TickMark;